import {
  APPLY_TYPE,
  APPROVAL_STATE,
  VACATION_TYPE2,
  WORK_PLACE,
  START_END_TYPE,
  VACATION_UPDATE_TYPE,
  WORK_STAT,
} from './index';

export const TypeGetter = {
  getMealCostType(inputKey) {
    const found = Object.values(APPLY_TYPE.MEAL_COST.TYPE).find(
      (value) => value.KEY === inputKey,
    );
    return found;
  },
  getExpenseType(inputKey) {
    const found = Object.values(APPLY_TYPE.EXPENSE_REPORT.TYPE).find(
      (value) => value.KEY === inputKey,
    );
    return found;
  },
  getBusinessTripType(inputKey) {
    const found = Object.values(APPLY_TYPE.BUSINESS_TRIP.TYPE).find(
      (value) => value.KEY === inputKey,
    );
    return found;
  },
  getApplyType(inputKey) {
    const found = Object.values(APPLY_TYPE).find((value) => value.KEY === inputKey);
    return found;
  },
  getApprovalStateType(inputKey) {
    const found = Object.values(APPROVAL_STATE).find((value) => value.KEY === inputKey);
    return found;
  },
  getWorkPlaceType(inputKey) {
    //파견지 판별 수정
    const found = Object.values(WORK_PLACE).find((value) => value.KEY === inputKey);
    if (found) {
      return found;
    } else {
      return inputKey;
    }
  },
  getVacationType(inputKey) {
    const found = Object.values(VACATION_TYPE2).find((value) => value.KEY === inputKey);
    return found;
  },
  getVacationUpdateType(inputKey) {
    const found = Object.values(VACATION_UPDATE_TYPE).find(
      (value) => value.KEY === inputKey,
    );
    return found;
  },
  getStartEndType(inputKey) {
    const found = Object.values(START_END_TYPE).find((value) => value.KEY === inputKey);
    return found;
  },
  getWorkStatType(inputKey) {
    const found = Object.values(WORK_STAT).find((value) => value.KEY === inputKey);
    return found;
  },
  // getVacationType (inputKey) {
  //   const found = Object.entries(VACATION_TYPE).find(([key, value]) => key === inputKey);
  //   return { KEY: found[0], NAME: found[1] };
  // },
};
